var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "checkbox",
        {
          key: option.value,
          ref: "checkboxes",
          refInFor: true,
          attrs: {
            value: option.value,
            id: `${_vm.id}_${index + 1}`,
            name: _vm.name,
          },
          on: { check: _vm.onCheck, uncheck: _vm.onUncheck },
        },
        [_vm._v("\n    " + _vm._s(option.label) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }